export enum PatientEventType {
  ANTECEDENTS = 'Antecedents',
}
